<template>
  <div id='trafico'>
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12>
           <base-material-card
          color="primary"
          icon="library_books"
          title="Configuración de Columnas de Tráfico"
          class="elevation-1 px-5 py-3"
        >
        
            
            <v-card-text>
              <v-card-title>
                <span class="headline" ></span>
              </v-card-title>
              <div class="row" >
              <div class= "col-6" >
              <v-select
                :items="estados"
                filled
                label="Estados de Tráfico"
                v-on:change=  "actualiza"
              ></v-select>
              </div>
              <div class= "col-6 caption text-info" v-if="sub_estados.length>0" >
                *Mantenga presionado el mouse y arrastre si desea cambiar el orden.
              </div>
              </div>
              <div class="row" >
              <div id="app" class="col-12" >
             <!--  <v-jstree :data="estados" 
              draggable
              allow-batch
              whole-row 
              :item-events="itemEvents"
              @item-click="itemClick" >

              </v-jstree> -->
             
              <draggable tag="ul" :list="sub_estados" class="list-group" 
              v-bind="dragOptions"
              @start="drag = true"
              @end="drag = false" 
              :options="{handle:'.handle'}"
              >
              <transition-group type="transition" :name="!drag ? 'flip-list' : null" >
                    <li
                      class="list-group-item"
                      v-for="(element) in sub_estados"
                      :key="element.id"
                    >
                      <div class="row " >
                        <div class="col-1" > 
                             <span class="handle" >
                                  <v-icon>drag_handle</v-icon>
                              </span>
                         </div>
                       
                          <div class="col-7" >     
                            <div class="subheading font-weight-bold" >{{ element.text}} </div></i>
                          </div>
                          <div class="col-2" >  

                          </div>
                          <div class="col-2" >  
                            <v-switch v-model="element.visible" label="Visible" hide-details color="primary"
                              v-if="!element.requerido" ></v-switch>
                          </div>
                      </div>
                      
                    </li>
               </transition-group>
            </draggable>
             
              </div>
          
            </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
              
                color="success"
                @click.native="guardar()"
                ><v-icon>done</v-icon> Actualizar
              </v-btn>
            </v-card-actions>
                        </base-material-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>

</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";

export default {
  components: {
     draggable
  },
   computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  mounted() {
       this.id_cliente = this.$local_storage.get("id_cliente");
     
       this.getEstados();
  }, 
 
  methods: {
        actualiza (val){
          let childs =  this.estados.filter(estado=>estado.text==val);
          this.sub_estados = childs[0].children;
        },
        guardar(){
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          let datos = [];
          let index = 1;
          for (var i = 0; i < this.estados.length; i++) {
            let childrens = this.estados[i].children;
            for (var j = 0; j < childrens.length; j++) {
               datos.push({
                                                  'cliente': this.id_cliente,
                                                  'columna_trafico': childrens[j].id,
                                                  'visible':childrens[j].visible,
                                                  'orden': index
                                              
                                              });
                                              index++;
          
            }
          }
          axios
          .post(this.$hostname + "catalogos/estados_trafico/save_columnas_cliente/", datos)
          .then(response => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "Los estados se actualizaron correctamente.",
                footer: ""
              });
          }).catch(error => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: 'Ocurrió un error al actualizar los estados.',
                footer: ""
              });
          }).then(()=>{
                  this.$root.$dialogLoader.hide();
                });
          
        },
       async getEstados(){
         this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          await axios.get(this.$hostname + "catalogos/estados_trafico/list_estados/", {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                })
                .then(async response => {
                   let datos = [];
                   let childs = [];
                                await axios.post(this.$hostname + "catalogos/estados_trafico/list_columnas/", {"cliente":this.id_cliente},{
                                      "Content-type": "application/json",
                                      "Access-Control-Allow-Origin": "*",
                                      "cache-control": "no-cache"
                                  })
                                  .then(response => {
                                    let datos = [];

                                          for (var i = 0; i < response.data.length; i++) {
                                            
                                              datos.push({
                                                  'id': response.data[i].id_columna_trafico,
                                                  'text': response.data[i].header,
                                                  "icon": "fa fa-check",
                                                  'requerido':response.data[i].requerido,
                                                  'visible':response.data[i].visible,
                                                  'id_estado': response.data[i].id_estado_trafico, 
                                                  'requerido': response.data[i].requerido, 
                                              
                                              });
                                          }                        
                                        
                                          this.sub_estados = datos;

                                  })
                                  .catch(error => {
                                      this.$swal({
                                          type: "error",
                                          title: "¡Operación no Permitida!",
                                          text: 'Ocurrió un error al obtener los subestados de trafico',
                                          footer: ""
                                      });
                                  });
                    let subestados = this.sub_estados;
                        for (var i = 0; i < response.data.length; i++) {
                          childs =  subestados.filter(subestado=>subestado.id_estado==response.data[i].id_estado_trafico);
                      
                            datos.push({
                                'id': response.data[i].id_estado_trafico,
                                'text': response.data[i].nombre,
                                'icon':'fa fa-folder',
                                'dragDisabled': true,
                                "opened": true,
                                'children': childs
                            });

                        }          
                        this.estados = datos;
                        this.sub_estados = [];
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al obtener los estados',
                        footer: ""
                    });
                }).then(()=>{
                  this.$root.$dialogLoader.hide();
                });
        }
    },

  data: () => ({ fab: false,
    id_cliente: 0,
    sub_estados: [],
    estados: [],
    drag: false,
    subestado:"",
    url_actions: "trafico/",
    url_list:  "trafico/list/",
    tabla: 1,
    title: "Configurar Columnas de Tráfico",
    
     data: [
        ],
    
    breadcrumbs: [
      {
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Utilerías",
        disabled: true,
        to: ""
      },
      {
        text: "Configurar Columnas de Tráfico",
        disabled: true,
        to: ""
      },      
     
    ],
   
  }),
 
};
</script>
<style scoped>

.handle {
            padding: 5px;
            margin-right: 10px;
            cursor: move;
        }

</style>